<script setup>

const props = defineProps({
  interval: {
    type: Number,
    default: 5000
  }
});

const refreshPage = () => {
  location.reload();
};

setInterval(refreshPage, props.interval);

</script>
<template></template>